import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { LgvFormUtilityService } from '../../../core/services/lgv-form-utility.service';
import { Console } from 'console';
import { BehaviorSubject, Subject, last, takeUntil } from 'rxjs';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { LgvFormlyModel } from '../../../data-models/formly.model';

@Component({
    selector: 'formly-repeating-section',
    templateUrl: './formly-repeating-section.component.html',
    styleUrls: ['./formly-repeating-section.component.scss'],
})
export class FormlyRepeatingSectionComponent extends FieldArrayType implements OnInit, OnDestroy {

    onDestroy$ = new Subject();

    get parentIsRepeater():boolean { return this.field.parent?.parent?.id.includes('repeating');}
    get changeSummaryKey():string { 
        if(this.parentIsRepeater){
            let index = +this.field.parent.key;
            return this.lgvFormSvc.buildChangeMapKey(this.lgvFormSvc.curLevel1$.value, this.lgvFormSvc.curLevel2$.value, index);
        }else{
            return this.lgvFormSvc.buildChangeMapKey(this.lgvFormSvc.curLevel1$.value, this.lgvFormSvc.curLevel2$.value);
        }
    }

    schemaHasConfirmIfNoItems$ = new BehaviorSubject(false);
    schemaConfirmIfNoItemsMessage$ = new BehaviorSubject('');
    numItems$ = new BehaviorSubject(0);
    confirmedNoItemsForForm = false;
    shouldHide$ = new BehaviorSubject(false);
 
    constructor(public lgvFormSvc: LgvFormUtilityService) {
        super();
    }


    ngOnInit(): void {
        this.confirmedNoItemsForForm = this.lgvFormSvc.haveUserConfirmedNoItems(this.buildUserConfirmNoItemObj());
        this.updateConfirmNoItemsStatus();

        this.field.formControl.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(x=>{
            // console.log('Field Changes');
            this.updateConfirmNoItemsStatus();
        });

        this.field.parent.formControl.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(x=>{
            // console.log('Parent Field Changes');
            // check parent changes so we can react to sybling value changes.
            this.updateHiddenStatus();
        });

        
        if(this.field?.expressions?.hide && this.field.expressions.hide.toString().includes('loanApp?.borrower?.currentAddress?.residencyDurationInMonths')) {
            this.updateHiddenStatus();
        }
    }

    updateHiddenStatus(){

        // formly is not hiding repeaters from hide expression, so manually do it here...
        let tempHidden = false;

        let checkForResidencyDuration = this.field?.expressions?.hide && this.field.expressions.hide.toString().includes('.residencyDurationInMonths');

        // this.field?.expressions?.hide && this.field.expressions.hide.toString().includes('loanApp?.borrower?.currentAddress?.residencyDurationInMonths')
        if(checkForResidencyDuration) {
            let residencyDuration = 0;
            if(this.field.expressions.hide.toString().includes('.borrower?.currentAddress?.residencyDurationInMonths'))
            {
                residencyDuration = this.lgvFormSvc.dataModel$.value?.loanApp?.borrower?.currentAddress?.residencyDurationInMonths;
            }
            else if(this.field.expressions.hide.toString().includes('.borrower?.coBorrower?.currentAddress?.residencyDurationInMonths')){
                residencyDuration = this.lgvFormSvc.dataModel$.value?.loanApp?.borrower?.coBorrower?.currentAddress?.residencyDurationInMonths;
            }

            // let residencyDuration = this.lgvFormSvc.dataModel$.value?.loanApp?.borrower?.currentAddress?.residencyDurationInMonths;
            if(residencyDuration && residencyDuration > 23){
                if(this.shouldHide$.value === false){
                    this.shouldHide$.next(true);
                }
            }else{
                if(this.shouldHide$.value === true){
                    this.shouldHide$.next(false);
                }
            }
        }
    }

      ngOnDestroy(): void {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    onAdd() {
        this.add();
    }

    onRemove(index: number) {
        this.remove(index);
    }


    updateConfirmNoItemsStatus() {

        if (this.field?.props['confirmIfNoItems']) {
            // console.log('CONFIRM IF NO ITEMS');
            this.schemaHasConfirmIfNoItems$.next(true);
        }

        if (this.field?.props['confirmIfNoItemsMessage']) {
            let msg = this.field?.props['confirmIfNoItemsMessage'];
            this.schemaConfirmIfNoItemsMessage$.next(msg);
        }

        if (this.field?.fieldGroup?.length) {
            this.numItems$.next(this.field?.fieldGroup?.length);
        }
        else {
            this.numItems$.next(0);
        }
        this.lgvFormSvc.updateChangeMap(this.field.parent.fieldGroup, this.parentIsRepeater ? +this.field.parent.key : null);
    }

    buildUserConfirmNoItemObj(): LgvFormlyModel.UserConfirmedNoItem{
        return { changeSummaryKey: this.changeSummaryKey, modelKey: this.field.key.toString() }
    }

    onConfirmChanged(event: MatCheckboxChange) {
        // if schema has confirmIfNoItems, then it's a validation error if the array has no items.  The list of user confirmations is save in lgvFormSvc.confirmedNoItemsList$
        let summary: LgvFormlyModel.GroupSummary;

        if (event.checked) {
            this.lgvFormSvc.addConfirmedNoItems(this.buildUserConfirmNoItemObj());

        } else {
            this.lgvFormSvc.removeConfirmedNoItems(this.buildUserConfirmNoItemObj());
        }

        this.lgvFormSvc.updateChangeMap(this.field.parent.fieldGroup, this.parentIsRepeater ? +this.field.parent.key : null);
    }
}